import React, { Component } from 'react';

import styles from './PricingCards.module.css';

export default class PricingCards extends Component {
  render() {
    return (
      <div className={styles.wrapper}>
        <div className={[styles.card, styles.first].join(' ')}>
          <h3>Unlimited</h3>
          <span className={styles.subtitle}>Für einen Behandler</span>
          <ul>
            <li>Online-Terminvermittlung, insbesondere von kurzfristig ausgefallenen Terminen</li>
            <li>Unbegrenztes Terminkontingent</li>
            <li>Installation und persönliche Einführung</li>
            <li>Schnittstelle mit Ihrer Praxissoftware möglich</li>
            <li>Zusätzliche E-Mail-Benachrichtigung des Patienten kurz vor den Terminen</li>
            <li>Support durch persönlichen Ansprechpartner</li>
            <li className={styles.green}>Integration in Ihre Website</li>
            <li className={styles.green}>Top-10-Listing für Ihre Region</li>
          </ul>

          <div className={styles.price}>91<span className={styles.euro}>€</span> <span className={styles.small}>/ Monat</span> <span
            className={styles.smaller}>exkl. MwSt.</span></div>
        </div>
        <div className={[styles.card, styles.highlighted].join(' ')}>
          <h3>Professional</h3>
          <span className={styles.subtitle}>Für einen Behandler</span>
          <ul>
            <li>Online-Terminvermittlung, insbesondere von kurzfristig ausgefallenen Terminen</li>
            <li>Unbegrenztes Terminkontingent</li>
            <li>Installation und persönliche Einführung</li>
            <li>Schnittstelle mit Ihrer Praxissoftware möglich</li>
            <li className={styles.green}>Zusätzliche E-Mail-Benachrichtigung des Patienten kurz vor den Terminen</li>
            <li className={styles.green}>Support durch persönlichen Ansprechpartner</li>
          </ul>

          <div className={styles.price}>55<span className={styles.euro}>€</span> <span className={styles.small}>/ Monat</span> <span
            className={styles.smaller}>exkl. MwSt.</span></div>
        </div>
        <div className={[styles.card, styles.last].join(' ')}>
          <h3>Essential</h3>
          <span className={styles.subtitle}>Für einen Behandler</span>
          <ul>
            <li className={styles.green}>Online-Terminvermittlung, insbesondere von kurzfristig ausgefallenen Terminen</li>
            <li className={styles.green}>Unbegrenztes Terminkontingent</li>
            <li className={styles.green}>Installation und persönliche Einführung</li>
            <li className={styles.green}>Schnittstelle mit Ihrer Praxissoftware möglich</li>
          </ul>

          <div className={styles.price}>37<span className={styles.euro}>€</span> <span className={styles.small}>/ Monat</span> <span
            className={styles.smaller}>exkl. MwSt.</span></div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/PricingCards/PricingCards.js